//import  Effect from 'redux-saga';
import { call, put, takeEvery, Effect } from 'redux-saga/effects';
import ApplicationDataService, { Service } from './service';
import {
    SubmissionRequest, submissionSuccess,
    submissionFailure, SubmissionDataActionTypes, DeleteSubmission,
    deleteSubmissionSuccess, deleteSubmissionFailure, closeDeleteRecordDialog,
    closeEditFormDialog, getColumnConfigFailure, GetColumnConfig, getColumnConfigSuccess
} from './state/submission/submissionDataActions';
import { loadFormSuccess, loadFormFailure, LoadFormData, SaveFormData, saveFormDataFailure, UpdateForm, updateFormSuccess, updateFormFailure, FormDataActionTypes, saveFormDataSuccess, saveFormResponse } from './state/form/formDataActions';
import { applicationDataSuccess, applicationDataFailure } from './state/form/applicationDataActions';
const config = require(`${__dirname}/config.${process.env.NODE_ENV}.json`);

let service: Service = ApplicationDataService;

const ssoUrl = config.ssoUrl;

export function injectService(injectedService: Service) {
    service = injectedService;
}

export function* loadFormData(action: LoadFormData): Iterator<Effect> {
    const { loadFormDataService } = service;
    try {
        const data = yield call(loadFormDataService, action.data);
        yield put(loadFormSuccess({
            formAlias: action.data.formAlias,
            formData: data
        }));
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(loadFormFailure());
        yield put(applicationDataFailure(`Form load failed!:${new Date()}`))
    }
}

export function* saveFormData(action: SaveFormData): Iterator<Effect> {
    const { saveFormDataService } = service;
    try {
            const response = yield call(saveFormDataService, action.data);
            // yield put(saveFormDataFailure());
            yield put(saveFormResponse(response));
            yield put(applicationDataSuccess(`Donation saved successfully!:${new Date()}`))
            yield put(saveFormDataSuccess(`Donation saved successfully!:${new Date()}`))
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(applicationDataFailure(`Donation creation failed!:${new Date()}`))
        yield put(saveFormDataFailure(e.response.data || 'Failed to save the form!'));
    }
}

export function* getSubmissionsData(action: SubmissionRequest): Iterator<Effect> {
    const { getSubmissions } = service;
    try {
        const submissions = yield call(getSubmissions, action.data);
        yield put(submissionSuccess(submissions));
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(applicationDataFailure(`Get donations failed!:${new Date()}`))
        yield put(submissionFailure());
    }
}


export function* deleteSubmissionData(action: DeleteSubmission): Iterator<Effect> {
    const { deleteSubmission } = service;
    try {
        yield call(deleteSubmission, action.data);
        yield put(deleteSubmissionSuccess());
        yield put(closeDeleteRecordDialog());
        yield put(applicationDataSuccess(`Donation deleted successfully!:${new Date()}`))
        // yield put(submissionRequest(action.data.gridData));
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(applicationDataFailure(`Donation delete failed!:${new Date()}`))
        yield put(deleteSubmissionFailure());
    }
}

export function* updateFormData(action: UpdateForm): Iterator<Effect> {
    const { updateFormDataService } = service;
    try {
        yield call(updateFormDataService, action.data);
        yield put(updateFormSuccess());
        yield put(closeEditFormDialog());
        yield put(applicationDataSuccess(`Donation updated successfully!:${new Date()}`))
        // yield put(submissionRequest(action.data.loadFormData));
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(updateFormFailure(e.response.data || 'Failed to update the form!'));
        yield put(applicationDataFailure(`Donation update failed!:${new Date()}`))
    }
}

export function* getColumnConfigData(action: GetColumnConfig): Iterator<Effect> {
    const { getColumnConfig } = service;
    try {
        const data = yield call(getColumnConfig, action.data);
        // @ts-ignore
        yield put(getColumnConfigSuccess(data.columns));
        // yield put(submissionRequest(action.data.loadFormData));
    } catch (e) {
        if (e.response && e.response.status === 401 && config.ssoEnabled) {
            window.location.href = ssoUrl;
        }
        yield put(applicationDataFailure(`Column retrieval failed!:${new Date()}`))
        yield put(getColumnConfigFailure());
    }
}

export function* loadAppMessageSaga(): Iterator<Effect> {
    yield takeEvery(FormDataActionTypes.LOAD_FORM_DATA, loadFormData);
    yield takeEvery(FormDataActionTypes.SAVE_FORM_DATA, saveFormData);
    yield takeEvery(FormDataActionTypes.UPDATE_FORM, updateFormData);
    yield takeEvery(SubmissionDataActionTypes.SUBMISSION_REQUEST, getSubmissionsData);
    yield takeEvery(SubmissionDataActionTypes.DELETE_SUBMISSION, deleteSubmissionData);
    yield takeEvery(SubmissionDataActionTypes.GET_COLUMN_CONFIG, getColumnConfigData);
}

export default [
    loadAppMessageSaga
]]